// extracted by mini-css-extract-plugin
export default {"pagetitle":"PagePagination_pagetitle__fozvv","link__element":"PagePagination_link__element__xgDGS"};